import { Routes } from '@angular/router';
import { CreditCardPaymentComponent } from './components/credit-card-payment/credit-card-payment.component';
import { PaymentComponent } from './components/payment/payment.component';
import { TextToPayComponent } from './components/text-to-pay/text-to-pay.component';

export const routes: Routes = [
    {
        path: 'tp',
        component: TextToPayComponent
    },
    {
        path: 'paynow',
        component: PaymentComponent
    },
    {
        path: '**',
        loadComponent: () => import('./components/page-not-found.component').then(m => m.PageNotFoundComponent)
    }
];
